module.exports = __webpack_public_path__ + "img/23.4e662a38.png";